import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import InventoryComp  from "./Component/InventoryComp"

const Inventory =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <InventoryComp />
        </div>
        <Footer />
        </>
    )
}

export default Inventory